import React from "react";
import "./App.scss";
import { Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/HomePage/HomePage";
import ProtectedRoute from "./shared/components/ProtectedRoute";
import { UsersPage } from "./pages/UsersPage/UsersPage";
import { VideoPage } from "./pages/ContentPage/VideoPage";
import { AdminsPage } from "./pages/AdminsPage/AdminsPage";
import { AIPrompts } from "./pages/AIPrompts/AIPrompts";
import { MusicPage } from "./pages/MusicPage/MusicPage";
import { BooksPage } from "./pages/BooksPage/BooksPage";
import { UserPage } from "./pages/UserPage/UserPage";
import { ProfilePage } from "./pages/ProfilePage/ProfilePage";
import { ProfileActivityPage } from "./pages/ProfileActivityPage/ProfileActivityPage";
import AuthFlow from "./pages/Authorization/AuthFlow";
import { StoryTeller } from "./pages/StoryTeller/StoryTeller";
import { FeaturedPage } from "./pages/FeaturedPage/FeaturedPage";
import { HomeContent } from "./pages/FeaturedPage/components/HomeContent/HomeContent";
import { VideoContent } from "./pages/FeaturedPage/components/VideoContent/VideoContent";
import { SongsContent } from "./pages/FeaturedPage/components/SongsContent/SongsContent";

export const App = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/users/:email" element={<UserPage />} />
        <Route path="/users/:email/:name" element={<ProfilePage />} />
        <Route
          path="/users/:email/:name/:contentType"
          element={<ProfileActivityPage />}
        />
        <Route path="/admins" element={<AdminsPage />} />
        <Route path="/videos" element={<VideoPage />} />
        <Route path="/songs" element={<MusicPage />} />
        <Route path="/books" element={<BooksPage />} />
        <Route path="/ai-prompts" element={<AIPrompts />} />
        <Route path="/story-teller/:item" element={<StoryTeller />} />
        <Route path="/featured-content" element={<FeaturedPage />} />
        <Route path="/featured-content/home" element={<HomeContent />} />
        <Route path="/featured-content/video" element={<VideoContent />} />
        <Route path="/featured-content/songs" element={<SongsContent />} />
      </Route>
      <Route path="/login" element={<AuthFlow />} />
    </Routes>
  );
};

